import { ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AccessTokenHttpInterceptor } from './common/core/data-access/http-client/interceptors/access-token-http.interceptor';
import { errorInterceptor } from './common/core/data-access/http-client/interceptors/error.interceptor';
import player from 'lottie-web';
import { DatePipe } from '@angular/common';
import { hmacInterceptor } from './common/core/data-access/http-client/interceptors/hmac.interceptor';
import { CoreErrorHandler } from './common';
import { DialogService } from 'primeng/dynamicdialog';
import { ReactiveFormsModule } from '@angular/forms';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function playerFactory() {
  return player;
}
export const appConfig: ApplicationConfig = {
  providers: [
    DatePipe,
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    provideHttpClient(withInterceptors([AccessTokenHttpInterceptor, errorInterceptor, hmacInterceptor]), withFetch()),
    provideClientHydration(),
    provideAnimations(),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
      // LottieModule.forRoot({ player: playerFactory })
    ),
    {
      provide: ErrorHandler,
      useClass: CoreErrorHandler
    },
    DialogService,
    importProvidersFrom(
      ReactiveFormsModule
      // FormlyModule.forRoot({
      //   types: [
      //     {
      //       name: 'input',
      //       extends: 'input' // Extends the default input type
      //     }
      //   ]
      // })
    )
  ]
};
